import { DataTableHeader } from 'vuetify/framework';
import { usePlatform } from '@/composables/usePlatform';

export function useBetsHeaders() {
    const { t } = useI18n();
    const platform = usePlatform();

    return computed<DataTableHeader[]>(() => [
        {
            title: t('bet.date'),
            key: 'createdAt',
            value: 'createdAt',
            align: 'start',
            sortable: false,
            width: 60,
        },
        {
            title: t('bet.bot') + '/' + t('bet.order'),
            key: 'botName',
            value: 'botName',
            align: 'start',
            sortable: false,
            minWidth: 120,
            width: 180,
        },
        ...(platform.isAggregator()
            ? [
                  {
                      title: t('bet.bookmaker'),
                      key: 'bookmakerId',
                      value: 'bookmakerId',
                      align: 'start',
                      sortable: false,
                      width: 50,
                  } as DataTableHeader,
              ]
            : []),
        {
            title: t('bet.status'),
            key: 'statusId',
            value: 'statusId',
            align: 'start',
            sortable: false,
            width: 60,
        },
        {
            title: t('bet.bet'),
            sortable: false,
            align: 'start',
            key: 'type',
            value: 'type',
            width: 130,
            nowrap: true,
        },
        {
            title: t('bet.odds'),
            sortable: false,
            align: 'center',
            key: 'odds',
            value: 'odds',
            width: 40,
        },
        {
            title: '',
            sortable: false,
            align: 'center',
            key: 'score',
            value: 'score',
            minWidth: 60,
            width: 75,
        },
        {
            title: t('bet.min'),
            sortable: false,
            align: 'center',
            key: 'minute',
            value: 'minute',
            minWidth: 45,
            width: 45,
        },
        {
            title: t('bet.stake'),
            sortable: false,
            align: 'end',
            key: 'stake',
            value: 'stake',
            width: 40,
        },
        {
            title: t('gameGrid.expected'),
            sortable: false,
            align: 'end',
            key: 'expected',
            value: 'expected',
            width: 40,
        },
    ]);
}
